import { createSlice } from '@reduxjs/toolkit';

/**
 * 본사 설정 화면 상태 — 만료 알림이 도는지 보는 값들.
 *
 * 수신자는 여기에 없다. 파트너가 자기 설정에서 정하고(/partners/mail-recipients), 그 화면은
 * 목록 하나를 통째로 저장하므로 리덕스를 거치지 않는다.
 *
 * 인증 서버 URL 도 여기에 없다. 발급 서버의 TFL_AUTH_SERVER_URL 환경변수가 발급 시점에
 * add_flag 로 실어 보내므로, 화면에서도 정하면 같은 값의 주인이 둘이 된다.
 */
const initialState = {
    mailSetting: {
        lastSendAt: null,
        lastSendStatus: null,
        lastSendError: null,
        lastSendFailedLicenses: [],
    },
    loading: false,
    testing: false,
    error: null,
};

export const settingSlice = createSlice({
    name: 'setting',
    initialState,

    reducers: {
        fetchMailSettingRequest: (state) => {
            state.loading = true;
        },
        fetchMailSettingSuccess: (state, action) => {
            state.loading = false;
            state.mailSetting = action.payload;
            state.error = null;
        },
        fetchMailSettingFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },

        testMailSettingRequest: (state) => {
            state.testing = true;
        },
        testMailSettingSuccess: (state) => {
            state.testing = false;
        },
        testMailSettingFailure: (state, action) => {
            state.testing = false;
            state.error = action.payload;
        },
    },
});

export const {
    fetchMailSettingRequest,
    fetchMailSettingSuccess,
    fetchMailSettingFailure,
    testMailSettingRequest,
    testMailSettingSuccess,
    testMailSettingFailure,
} = settingSlice.actions;

export default settingSlice.reducer;
